import React from "react";
import './../css/DevSVG.css';

const DevSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 582 473">
      <g id="Developer">
        <g id="BackgroundGlobe">
          <path
            id="Vector"
            fill="url(#paint0_linear_1_6)"
            d="M580.57 235.709a263.333 263.333 0 01-16.579 68.746 294.52 294.52 0 01-23.151 47.023c-2.063 3.406-4.24 6.784-6.402 10.091a293.027 293.027 0 01-10.714 15.081 283.572 283.572 0 01-30.203 33.921 248.732 248.732 0 01-30.261 24.663 7.29 7.29 0 00-2.829 8.168 7.288 7.288 0 006.956 5.132h3.308c.435 0 .869.028 1.3.085a12.208 12.208 0 0110.911 12.72 12.469 12.469 0 01-12.565 11.632H122.652a12.233 12.233 0 01-8.857-3.792 12.232 12.232 0 01-3.368-9.027 11.997 11.997 0 013.943-8.283 12.718 12.718 0 018.621-3.363 7.29 7.29 0 006.91-4.942 7.293 7.293 0 00-2.457-8.132c-23.18-17.893-61.99-54.655-83.856-112.787-10.77-28.607-17.427-62.386-16.112-101.664C32.846 62.684 183.667-24.125 359.49 5.881 535.314 35.885 591.029 129.677 580.57 235.708z"
          ></path>
          <path
            id="Vector_2"
            fill="#000"
            d="M493.535 410.585a861.898 861.898 0 01-21.484 38.034c-8.989 15.024-15.207 24.38-15.207 24.38H122.751a12.233 12.233 0 01-8.857-3.792 12.25 12.25 0 01-3.369-9.027 11.998 11.998 0 013.944-8.282 12.719 12.719 0 018.621-3.364 7.297 7.297 0 006.91-4.942 7.293 7.293 0 00-2.458-8.132 242.986 242.986 0 01-10.713-8.763 265.97 265.97 0 01-41.412-45.086 251.217 251.217 0 01-31.815-59.008c26.26 26.5 64.902 53.948 113.522 57.185 96.42 6.43 277.219-172.743 355.958-141.422 50.16 19.957 13.61 109.706-19.547 172.219z"
            opacity="0.08"
          ></path>
        </g>
        <g id="Bricks">
          <g id="LeftBricks">
            <path
              fill="#000"
              d="M139.047 337.81h30.529v-11.434h-30.529v11.434z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M104.83 337.81h30.528v-11.434H104.83v11.434z"
              opacity="0.25"
            ></path>
            <path
              fill="#fff"
              d="M121.946 353.895h30.528V342.46h-30.528v11.435z"
              opacity="0.25"
            ></path>
            <path
              fill="#fff"
              d="M87.742 353.895h30.529V342.46h-30.53v11.435z"
              opacity="0.25"
            ></path>
          </g>
          <g id="RightBricks">
            <path
              fill="#000"
              d="M379.292 42.656h-30.529V54.09h30.529V42.657z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M413.496 42.656h-30.529V54.09h30.529V42.657z"
              opacity="0.25"
            ></path>
            <path
              fill="#fff"
              d="M396.394 58.74h-30.529v11.435h30.529V58.74z"
              opacity="0.25"
            ></path>
            <path
              fill="#fff"
              d="M430.612 58.74h-30.529v11.435h30.529V58.74z"
              opacity="0.25"
            ></path>
          </g>
        </g>
        <g id="HTMLCard">
          <path
            fill="url(#paint1_radial_1_6)"
            d="M125.629 292.712c39.224-16.908 58.798-58.973 43.718-93.954-15.079-34.98-59.101-49.63-98.325-32.722-39.225 16.909-58.798 58.974-43.718 93.955 15.08 34.98 59.101 49.63 98.325 32.721z"
          ></path>
          <path
            fill="url(#paint2_linear_1_6)"
            d="M134.228 149.818v93.141a6.093 6.093 0 01-6.106 6.106H10.007a6.092 6.092 0 01-6.092-6.106v-93.141a6.09 6.09 0 016.092-6.092h118.115a6.102 6.102 0 015.641 3.758 6.09 6.09 0 01.465 2.334z"
          ></path>
          <path
            fill="#002A66"
            d="M59.036 159.811H15.081a2.328 2.328 0 01-1.648-.674 2.325 2.325 0 01-.684-1.644 2.331 2.331 0 012.332-2.318h43.956a2.317 2.317 0 012.318 2.318 2.302 2.302 0 01-2.319 2.318z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M59.036 175.527H15.081a2.308 2.308 0 01-1.648-.674 2.31 2.31 0 01-.684-1.644 2.318 2.318 0 012.332-2.318h43.956a2.317 2.317 0 011.643.675 2.31 2.31 0 01.675 1.643 2.307 2.307 0 01-1.43 2.146 2.316 2.316 0 01-.889.172z"
          ></path>
          <path
            fill="#002A66"
            d="M73.736 191.244H15.08a2.333 2.333 0 01-2.332-2.318 2.316 2.316 0 012.332-2.36h58.655a2.32 2.32 0 012.261 2.36 2.33 2.33 0 01-2.261 2.318z"
          ></path>
          <path
            fill="#002A66"
            d="M73.736 235.256H15.08a2.308 2.308 0 01-1.648-.674 2.31 2.31 0 01-.684-1.644 2.318 2.318 0 012.332-2.318h58.655a2.32 2.32 0 010 4.636z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M116.405 235.256H86.823a2.31 2.31 0 01-1.657-.669 2.31 2.31 0 01-.689-1.649 2.318 2.318 0 012.332-2.318h29.596a2.33 2.33 0 011.648.674 2.324 2.324 0 01.684 1.644 2.32 2.32 0 01-2.332 2.318z"
          ></path>
          <path
            fill="#fff"
            d="M46.316 201.844v6.685a.976.976 0 00.975.976h3.703a.966.966 0 00.962-.976v-6.685a.975.975 0 01.975-.975h.353a.975.975 0 01.975.975v18.176a.976.976 0 01-.975.975h-.353a.974.974 0 01-.975-.975v-7.462a.965.965 0 00-.59-.901.966.966 0 00-.372-.075h-3.703a.975.975 0 00-.975.976v7.462a.976.976 0 01-.975.975h-.353a.974.974 0 01-.976-.975v-18.176a.975.975 0 01.976-.975h.353a.975.975 0 01.975.975z"
          ></path>
          <path
            fill="#fff"
            d="M59.22 202.933h-1.724a.975.975 0 01-.975-.976v-.113a.975.975 0 01.975-.975h7.703a.975.975 0 01.96.975v.113a.976.976 0 01-.96.976H63.46a.974.974 0 00-.975.975v16.112a.958.958 0 01-.961.975h-.367a.964.964 0 01-.893-.603.958.958 0 01-.069-.372v-16.112a.976.976 0 00-.975-.975z"
          ></path>
          <path
            fill="#fff"
            d="M80.463 212.331c-.155-2.657-.31-5.653-.212-7.872h-.127a104.182 104.182 0 01-1.611 6.982l-2.516 9.427h-1.413l-2.36-9.045c-.665-2.559-1.259-5.046-1.64-7.364h-.1c0 2.346-.112 5.159-.24 8.028l-.339 7.576a.976.976 0 01-.975.932h-.099a.963.963 0 01-.918-.641.975.975 0 01-.057-.39l1.074-18.176a.976.976 0 01.961-.919h.82a.961.961 0 01.933.735l2.176 8.48c.679 2.657 1.188 4.622 1.612 6.926h.084c.396-2.304.834-4.24 1.498-6.926l2.078-8.48a.99.99 0 01.947-.735h.89a.99.99 0 01.976.919l1.046 18.176a.978.978 0 01-.58.948.969.969 0 01-.381.083h-.198a.97.97 0 01-.975-.932l-.354-7.732z"
          ></path>
          <path
            fill="#fff"
            d="M87.12 200.869h.368a.964.964 0 01.892.603c.047.118.07.245.069.372v16.24a.964.964 0 00.975.961h3.731a.964.964 0 01.892.603c.048.118.071.245.07.372a.958.958 0 01-.962.975H87.12a.964.964 0 01-.892-.603.958.958 0 01-.069-.372v-18.176a.962.962 0 01.961-.975z"
          ></path>
          <path
            style={{ mixBlendMode: "color-dodge" }}
            fill="url(#paint3_radial_1_6)"
            d="M116.151 245.39c6.877 0 12.452-5.575 12.452-12.452s-5.575-12.451-12.452-12.451-12.452 5.574-12.452 12.451c0 6.877 5.575 12.452 12.452 12.452z"
          ></path>
        </g>
        <g id="SmileCard">
          <path
            fill="url(#paint4_linear_1_6)"
            d="M75.332 31.957H294.97a4.238 4.238 0 014.24 4.24V41.2H71.05v-4.96a4.24 4.24 0 014.282-4.283z"
          ></path>
          <path
            fill="#B3B3FF"
            d="M71.05 41.229h228.259v135.98a5.088 5.088 0 01-5.088 5.088H76.152a5.089 5.089 0 01-5.088-5.088V41.229h-.014z"
            opacity="0.86"
          ></path>
          <path
            fill="#EEF8FF"
            d="M289.416 36.593a1.612 1.612 0 11-3.224-.002 1.612 1.612 0 013.224.002z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M279.593 36.593a1.612 1.612 0 11-3.224-.002 1.612 1.612 0 013.224.002z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M269.742 36.593a1.612 1.612 0 11-3.224-.002 1.612 1.612 0 013.224.002z"
          ></path>
          <path
            fill="#fff"
            d="M210.875 58.74H94.088a2.317 2.317 0 01-2.318-2.332 2.318 2.318 0 012.318-2.318h116.787a2.333 2.333 0 012.318 2.318 2.333 2.333 0 01-2.318 2.332z"
          ></path>
          <path
            fill="#fff"
            d="M210.875 73.383H94.088a2.317 2.317 0 01-2.318-2.332 2.318 2.318 0 012.318-2.318h116.787a2.333 2.333 0 012.318 2.318 2.333 2.333 0 01-2.318 2.332z"
          ></path>
          <path
            fill="#002A66"
            d="M147.838 83.376h-53.75a2.318 2.318 0 000 4.635h53.75a2.317 2.317 0 100-4.635z"
          ></path>
          <path
            fill="#002A66"
            d="M210.875 146.002H94.088a2.298 2.298 0 01-1.643-.675 2.298 2.298 0 01-.675-1.643 2.304 2.304 0 012.318-2.346h116.787a2.319 2.319 0 012.318 2.318 2.323 2.323 0 01-2.318 2.346z"
          ></path>
          <path
            fill="#002A66"
            d="M147.838 160.644H94.13a2.298 2.298 0 01-2.192-1.438 2.304 2.304 0 01-.168-.908 2.302 2.302 0 012.318-2.318h53.708a2.297 2.297 0 011.643.675 2.305 2.305 0 01.675 1.643 2.302 2.302 0 01-2.276 2.346z"
          ></path>
          <path
            fill="#002A66"
            d="M258.321 68.38a19.646 19.646 0 1019.632 19.645 19.675 19.675 0 00-19.632-19.645zm0 35.942a16.314 16.314 0 01-15.08-10.062 16.311 16.311 0 1131.377-6.235 16.325 16.325 0 01-16.297 16.297z"
          ></path>
          <path
            fill="#002A66"
            d="M266.463 92.45a11.536 11.536 0 01-16.297 0 1.179 1.179 0 10-1.667 1.667 13.905 13.905 0 0019.631 0 1.18 1.18 0 00-.834-2.013c-.312 0-.612.124-.833.345z"
          ></path>
          <path
            fill="#002A66"
            d="M251.255 86.951a1.965 1.965 0 10-1.965-1.964 1.98 1.98 0 001.965 1.964z"
          ></path>
          <path
            fill="#002A66"
            d="M265.388 86.951a1.966 1.966 0 10-1.964-1.964 1.978 1.978 0 001.964 1.964z"
          ></path>
          <path
            fill="url(#paint5_linear_1_6)"
            d="M102.314 129.564a1.871 1.871 0 01-1.414-.593l-8.635-9.244a2.176 2.176 0 010-2.826l8.847-9.484a1.85 1.85 0 011.35-.591 1.847 1.847 0 011.35.591 2.147 2.147 0 010 2.827l-7.42 7.957 7.279 7.788a2.145 2.145 0 010 2.826 1.869 1.869 0 01-1.357.749z"
          ></path>
          <path
            fill="url(#paint6_linear_1_6)"
            d="M129.973 129.564a1.83 1.83 0 01-1.413-.593 2.15 2.15 0 010-2.827l7.279-7.788-7.435-7.957a2.145 2.145 0 010-2.827 1.852 1.852 0 012.714 0l8.777 9.399a2.134 2.134 0 010 2.827l-8.636 9.244a1.846 1.846 0 01-1.286.522z"
          ></path>
          <path
            fill="url(#paint7_linear_1_6)"
            d="M111.854 132.109a1.832 1.832 0 01-.707-.156 2.106 2.106 0 01-1.06-2.671l8.579-22.529a1.858 1.858 0 011.795-1.295c.264.004.525.065.764.178.478.228.852.629 1.047 1.122a2.097 2.097 0 01-.001 1.535l-8.636 22.544a1.925 1.925 0 01-1.781 1.272z"
          ></path>
          <path
            fill="#002A66"
            d="M288.652 123.84h-60.661a5.499 5.499 0 01-5.498-5.484V57.695a5.498 5.498 0 015.498-5.498h60.661a5.498 5.498 0 015.484 5.498v60.661a5.48 5.48 0 01-5.484 5.484zm-60.661-68.308a2.153 2.153 0 00-2.015 1.33 2.145 2.145 0 00-.162.833v60.661a2.148 2.148 0 002.162 2.149h60.662a2.164 2.164 0 001.547-.614c.204-.2.366-.439.477-.702.11-.264.167-.547.167-.833V57.695a2.148 2.148 0 00-2.148-2.163h-60.69z"
          ></path>
          <path
            fill="url(#paint8_linear_1_6)"
            d="M200.373 108.59v-1.88a1.299 1.299 0 00-1.3-1.286h-3.081a9.703 9.703 0 00-1.187-2.827l2.162-2.247a1.278 1.278 0 00.379-.911 1.286 1.286 0 00-.379-.912l-1.328-1.329a1.302 1.302 0 00-1.838 0l-2.176 2.177a9.706 9.706 0 00-2.827-1.187V95.12a1.3 1.3 0 00-1.286-1.3h-1.894a1.301 1.301 0 00-1.286 1.3v3.08c-1 .244-1.954.645-2.827 1.188l-2.177-2.177a1.298 1.298 0 00-1.837 0l-1.329 1.329a1.286 1.286 0 000 1.823l2.177 2.191a9.68 9.68 0 00-1.187 2.827h-3.081a1.286 1.286 0 00-1.287 1.286v1.88a1.299 1.299 0 001.287 1.3h3.081a9.703 9.703 0 001.187 2.827l-2.177 2.176a1.296 1.296 0 00-.379.912 1.293 1.293 0 00.379.912l1.329 1.413a1.302 1.302 0 001.837 0l2.092-2.191c.87.554 1.825.96 2.827 1.202v3.038a1.284 1.284 0 001.286 1.286h1.894a1.285 1.285 0 001.286-1.286v-3.024a9.349 9.349 0 002.827-1.202l2.176 2.191a1.304 1.304 0 001.838 0l1.328-1.413a1.292 1.292 0 000-1.824l-2.176-2.176a9.692 9.692 0 001.187-2.827h3.081a1.295 1.295 0 001.399-1.272zm-12.932 4.325a5.324 5.324 0 01-5.631-2.804 5.33 5.33 0 017.181-7.181 5.334 5.334 0 012.803 5.632 5.341 5.341 0 01-4.367 4.353h.014z"
          ></path>
        </g>
        <g id="Boy">
          <g id="BoyShoes">
            <g id="BoyLeftShoe">
              <path
                fill="url(#paint9_linear_1_6)"
                d="M410.231 445.212l34.995-1.964s13.936-.17 1.795-7.307a40.09 40.09 0 01-5.739-4.127 44.138 44.138 0 01-10.133-12.989l-6.884 1.809-12.013 3.166h-.311c-.862 7.123-1.71 21.412-1.71 21.412z"
              ></path>
              <path
                fill="#010D19"
                d="M456.844 448.534s-.707-11.59-9.823-12.72c-9.116-1.131-10.148 7.787-10.148 7.787l-26.642-1.498-.707 6.374 47.32.057z"
              ></path>
              <path
                fill="#010D19"
                d="M424.265 420.563c1.075 3.463 4.071 11.307 9.71 13.696a11.11 11.11 0 017.307-2.516 44.125 44.125 0 01-10.133-12.989l-6.884 1.809z"
              ></path>
            </g>
            <g id="BoyRightShoe">
              <path
                fill="url(#paint10_linear_1_6)"
                d="M367.151 445.212l-35.009-1.964s-13.922-.17-1.781-7.307a39.896 39.896 0 005.724-4.127 44.236 44.236 0 0010.148-12.989l6.869 1.809 12.014 3.166h.325c.834 7.123 1.71 21.412 1.71 21.412z"
              ></path>
              <path
                fill="#010D19"
                d="M320.51 448.534s.707-11.59 9.823-12.72c9.116-1.131 10.148 7.787 10.148 7.787l26.67-1.441.707 6.374H320.51z"
              ></path>
              <path
                fill="#010D19"
                d="M353.017 420.563c-1.06 3.463-4.056 11.307-9.709 13.696a11.087 11.087 0 00-7.308-2.516 44.236 44.236 0 0010.148-12.989l6.869 1.809z"
              ></path>
            </g>
          </g>
          <g id="BoyPant">
            <path
              fill="url(#paint11_linear_1_6)"
              d="M432.251 416.125l-23.434 2.502s-9.201-73.495-17.497-103.826c-2.671 6.261-8.056 28.875-13.102 51.404-5.866 26.317-11.236 52.521-11.236 52.521s-13.442 1.512-20.947-4.565c2.318-41.921 18.544-125.578 20.678-137.818v.297c.119.49.294.964.523 1.413.123.214.27.413.438.594 1.936 2.134 7.759 4.466 15.9 4.72 8.763.283 20.198-1.851 32.381-9.271a9.508 9.508 0 00.155-3.859c.41.396 1.188 5.329 2.191 13.145 4.678 35.871 13.95 132.743 13.95 132.743z"
            ></path>
            <path
              fill="#A2A5AA"
              d="M430.984 414.996l-19.941 1.692a3.336 3.336 0 00-3.042 3.606l.039.465a3.336 3.336 0 003.606 3.041l19.942-1.692a3.335 3.335 0 003.041-3.605l-.039-.465a3.336 3.336 0 00-3.606-3.042z"
            ></path>
            <path
              fill="#A2A5AA"
              d="M369.455 421.185a3.562 3.562 0 01-3.449 2.657 2.672 2.672 0 01-.593 0h-.325l-18.883-4.975-.975-.268a3.58 3.58 0 01-2.786-3.948 3.57 3.57 0 011.239-2.277 3.572 3.572 0 012.451-.842c.311.001.62.044.919.127l19.787 5.23a3.576 3.576 0 012.615 4.296z"
            ></path>
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.668"
              d="M407.559 283.382s-.537 7.759 7.237 9.356"
              opacity="0.25"
            ></path>
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.668"
              d="M411.164 295.862L426.4 411.461"
              opacity="0.25"
            ></path>
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.668"
              d="M387.617 313.373l-25.837 98.088"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M391.32 314.801c-2.672 6.261-8.057 28.875-13.102 51.404a252.013 252.013 0 011.413-33.921c3.194-23.646 11.689-17.483 11.689-17.483z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M418.386 283.367c-34.317 17.13-49.949-3.773-50.627-4.734 1.936 2.134 7.759 4.466 15.9 4.72 8.763.283 20.197-1.851 32.381-9.271a9.508 9.508 0 00.155-3.859c.424.396 1.187 5.385 2.191 13.144z"
              opacity="0.25"
            ></path>
          </g>
          <g id="BoyRightHand">
            <path
              fill="url(#paint12_linear_1_6)"
              d="M366.445 233.546l-1.64 6.403-.127.438-.382 1.512a20.506 20.506 0 01-7.066-1.06 23.979 23.979 0 01-6.205-3.067 30.359 30.359 0 01-1.611-1.215c.749-8.65 3.561-23.886 4.48-28.734.184-.975.297-1.527.297-1.527l12.254 27.25z"
            ></path>
            <path
              fill="url(#paint13_linear_1_6)"
              d="M366.982 241.051s-1.753 7.731-3.986 14.883c-1.597 5.046-3.42 9.809-5.06 11.307-3.957 3.745-14.134 9.893-14.134 9.893l-5.879-12.183 8.706-7.632 3.42-15.25.99-4.353a22.624 22.624 0 0013.257 4.127l.382-1.527 2.304.735z"
            ></path>
            <path
              fill="#000"
              d="M365.639 246.549a193.439 193.439 0 01-2.643 9.385c-4.551-2.827-10.021-9.809-12.947-13.795l.99-4.353a22.61 22.61 0 0013.257 4.127c.622 1.965 1.089 3.562 1.343 4.636z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M366.106 256.174a52.995 52.995 0 00-.425-9.413c-.226-1.06-.72-2.742-1.413-4.848a20.516 20.516 0 01-7.067-1.06c.65-2.318.58-6.855.693-12.522a34.8 34.8 0 00-.693-7.76c2.714 6.12 6.304 13.074 7.562 19.378 1.385 6.784 1.851 12.833 1.343 16.225z"
              opacity="0.25"
            ></path>
          </g>
          <g id="BoyBody">
            <path
              fill="url(#paint14_linear_1_6)"
              d="M416.04 274.082c-12.184 7.42-23.618 9.554-32.381 9.271-8.183-.254-14.02-2.614-15.928-4.749a3.134 3.134 0 01-.438-.593 6.425 6.425 0 01-.523-1.414v-.296a60.97 60.97 0 01-.707-12.056v-2.205c0-1.993 0-4 .085-5.88 0-2.487 0-4.791-.099-6.629a20.212 20.212 0 00-.311-2.19c0-.227-.071-.439-.113-.636v-.212c-.255-1.075-.721-2.672-1.414-4.636-.565-1.795-1.286-3.915-2.035-6.191-.226-.664-.452-1.413-.692-2.049-.679-2.078-1.414-4.24-2.149-6.473-.565-1.725-1.13-3.449-1.668-5.159a89.458 89.458 0 00-.65-2.05 110.952 110.952 0 01-3.137-11.787v-.353c0-.326-.085-.608-.128-.891l.424-.636.297-.438a48.377 48.377 0 019.343-9.611 69.23 69.23 0 012.629-2.007c.819-.594 1.3-.933 1.865-1.329l3.76-2.148a73.335 73.335 0 0123.928 0c2.098.33 4.171.802 6.205 1.414l.198 2.431.169 2.162.99 12.296.183 2.163.071.947c.099.424 1.187 4.734 2.657 10.883.17.678.339 1.413.509 2.091.862 3.576 1.809 7.647 2.827 11.873l.466 2.092a606.044 606.044 0 012.601 11.914c.141.721.282 1.414.438 2.106.89 4.438 1.668 8.593 2.191 12.014.113.749.212 1.413.311 2.134.141 1.088.254 2.078.325 2.954a9.52 9.52 0 01-.099 3.873z"
            ></path>
            <path
              fill="#000"
              d="M402.655 196.714l-48.69 11.476v-.353c0-.325-.085-.608-.128-.891l.424-.636.297-.438 47.984-11.307.113 2.149z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M403.899 211.172l-46.076 10.855a90.935 90.935 0 00-.65-2.049l46.542-10.968.184 2.162z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M407.079 225.137l-44.818 10.572c-.226-.665-.452-1.414-.693-2.05l45.002-10.614c.156.678.339 1.385.509 2.092z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M410.33 239.101l-44.324 10.444a19.906 19.906 0 00-.268-2.204l44.069-10.389.523 2.149z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M413.369 253.121l-47.362 11.18v-2.205l46.909-11.066c.156.706.297 1.399.453 2.091z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M415.87 267.269l-48.139 11.307a3.11 3.11 0 01-.438-.594 6.417 6.417 0 01-.523-1.413l48.789-11.505c.113.82.212 1.527.311 2.205z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M416.04 274.082c-12.184 7.42-23.618 9.554-32.381 9.271 10.403-4.353 7.35-14.854-2.247-16.776 9.667-7.138 17.441-13.47 15.872-36.593a101.46 101.46 0 01.905-21.61l5.724 3.788c.396 1.611 14.416 57.34 12.127 61.92z"
              opacity="0.25"
            ></path>
          </g>
          <g id="BoyHead">
            <path
              fill="#000"
              d="M396.083 190.707c-2.276 6.346-7.265 15.208-17.483 15.547-12.212.466-14.403-6.671-14.756-10.049a70.037 70.037 0 012.629-2.007c.82-.594 1.3-.933 1.865-1.329l3.76-2.148a73.335 73.335 0 0123.928 0l.057-.014z"
              opacity="0.25"
            ></path>
            <path
              fill="url(#paint15_linear_1_6)"
              d="M378.6 199.795a4.089 4.089 0 01-3.59 1.215 7.815 7.815 0 01-5.159-3.674 9.443 9.443 0 01-.961-1.88 3.395 3.395 0 01-2.12.085h-.297a18.023 18.023 0 01-4.947-2.036 24.878 24.878 0 01-7.717-7.25c-.424-.58-.82-1.173-1.187-1.753a49.251 49.251 0 01-1.131-1.88c7.336-.735 12.155-5.95 14.318-12.155 0 0 4.014 6.601 4.904 6.601.89 0 1.611-6.247 4.24-6.332a1.95 1.95 0 011.159.297c1.569.989 1.555 4.381.269 7.915-.806 2.233 2.501 4.098 3.222 4.24 0 0 .099 0 .184-.099a64.86 64.86 0 00.961 6.826c.14.777.32 1.546.537 2.304.481 1.512-.523 5.512-2.685 7.576z"
            ></path>
            <path
              fill="#FFB7A9"
              d="M359.42 175.004a15.912 15.912 0 01-8.056 7.307c-.24-.424-.452-.819-.636-1.201a35.744 35.744 0 008.692-6.106z"
            ></path>
            <path
              fill="url(#paint16_linear_1_6)"
              d="M385.129 168.559c-1.13 7.067-4.409 13.555-5.328 14.445-.085.085-.141.113-.184.099-.721-.184-4.028-2.049-3.222-4.24 1.54-4.24 1.258-8.297-1.414-8.212-2.671.085-3.392 6.332-4.24 6.332-.848 0-4.904-6.6-4.904-6.6-2.163 6.204-6.982 11.42-14.318 12.155h-.777l.678-.241a15.914 15.914 0 008.057-7.307 35.769 35.769 0 01-8.693 6.106 12.533 12.533 0 01-6.826 1.413 5.853 5.853 0 01-.481-.678c-6.431-9.583-1.809-29.596 7.223-33.426a18.208 18.208 0 01-5.159-2.827c4.014.876 14.261-2.671 17.822-2.205a5.89 5.89 0 014.679 3.279s4.48-4.028 9.568-2.332c-2.502-.099-4.367 2.94-4.367 2.94a16.638 16.638 0 0111.872 12.226c.584 2.996.588 6.076.014 9.073z"
            ></path>
            <path
              fill="#000"
              d="M378.599 199.795a4.078 4.078 0 01-3.59 1.215 7.817 7.817 0 01-5.158-3.674 9.443 9.443 0 01-.961-1.88c1.766-.41 4.113-1.852 5.922-6.346 1.682 1.201 1.399 8.763 3.787 10.685z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M351.364 182.326c-.24-.424-.452-.82-.636-1.202a35.744 35.744 0 008.692-6.106 15.914 15.914 0 01-8.056 7.308z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M376.126 170.906c-4.24 1.413-2.487 8.239-4.777 8.579-2.827.452-4.24-3.788-4.24-3.788a18.001 18.001 0 01-7.237 6.614 18.209 18.209 0 01-7.293 2.064 36.419 36.419 0 01-1.13-1.88c7.335-.735 12.155-5.95 14.317-12.155 0 0 4.014 6.601 4.905 6.601.89 0 1.611-6.247 4.24-6.332a1.95 1.95 0 011.215.297z"
              opacity="0.25"
            ></path>
            <path
              fill="#fff"
              d="M374.812 189.11c-1.809 4.494-4.156 5.936-5.922 6.346a3.666 3.666 0 01-2.346 0h-.071a18.052 18.052 0 01-4.947-2.035 24.87 24.87 0 01-7.717-7.251 3.239 3.239 0 012.29.876c2.205 1.753 4.24 5.767 9.243 6.841 5.003 1.074 8.184-2.897 9.47-4.777z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M374.995 173.506s-.862 2.502-.466 3.307c.396.806 3.109-1.653.466-3.307z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M385.129 168.559c-1.13 7.067-4.409 13.555-5.328 14.445-.085.085-.141.113-.184.099-.721-.184-4.028-2.049-3.222-4.24 1.54-4.24 1.258-8.297-1.414-8.212-2.671.085-3.392 6.332-4.24 6.332-.848 0-4.904-6.6-4.904-6.6-2.163 6.204-6.982 11.42-14.318 12.155h-.777l.678-.241a15.914 15.914 0 008.057-7.307 35.75 35.75 0 01-8.693 6.106 12.533 12.533 0 01-6.826 1.413 5.853 5.853 0 01-.481-.678c4.975-3.322 17.342-12.565 17.13-21.78a21.2 21.2 0 011.88 10.317 30.96 30.96 0 001.866-11.123 29.075 29.075 0 014.593 9.512 7.182 7.182 0 016.389-6.035c5.893-.933 6.134 7.646 6.134 7.646s2.035-3.081-.241-8.579c1.47.877 2.884 3.576 3.901 6.77z"
              opacity="0.25"
            ></path>
            <path
              fill="#0049B2"
              d="M377.045 203.993c-7.265.932-9.569-5.937-10.275-8.481.697.199 1.44.17 2.12-.084.249.66.571 1.291.961 1.879a7.833 7.833 0 005.158 3.675 4.076 4.076 0 003.59-1.215c2.163-2.064 3.166-6.064 2.714-7.633a23.57 23.57 0 01-.551-2.332l3.18-.084c.283 5.71-.579 13.469-6.897 14.275z"
            ></path>
          </g>
          <g id="BoyLeftHand">
            <path
              fill="url(#paint17_linear_1_6)"
              d="M416.294 219.978a1.929 1.929 0 01-.184.593 9.069 9.069 0 01-4.07 3.265 64.129 64.129 0 01-10.148 3.873l-1.032.311s-5.781-11.491-6.812-21.498c-.665-6.36.607-12.126 6.487-13.992a12.357 12.357 0 011.753-.41s8.098 4.509 13.738 26.854c.084.297.183.65.268 1.004z"
            ></path>
            <path
              fill="url(#paint18_linear_1_6)"
              d="M421.566 250.167c-2.304 4.467-39.278 22.501-39.278 22.501s-2.826 5.357-8.028 6.431c-5.201 1.074-9.116-1.795-12.14-1.965-3.025-.169-7.322 3.039-7.322 3.039a2.172 2.172 0 01-.975-.198c-.551-.282-.961-.975 0-2.671 4-7.137 18.685-8.381 19.787-8.918.509-.255 7.929-6.191 15.547-12.381 8.565-6.884 17.427-14.134 17.427-14.134l-3.533-10.756-1.145-3.463c3.208-.947 12.791-4.028 14.218-7.137.368 1.244.905 3.067 1.499 5.187 2.275 8.353 5.512 21.455 3.943 24.465z"
            ></path>
            <path
              fill="#000"
              d="M417.609 225.758c-4.764 4.467-11.307 5.301-14.572 5.414l-1.145-3.463c3.208-.947 12.791-4.028 14.218-7.138.368 1.244.905 3.067 1.499 5.187z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M416.294 219.978a1.929 1.929 0 01-.184.593 9.069 9.069 0 01-4.07 3.265 55.97 55.97 0 00-2.29-15.646 42.227 42.227 0 00-9.215-15.66 12.357 12.357 0 011.753-.41s8.098 4.509 13.738 26.854c.084.297.183.65.268 1.004z"
              opacity="0.25"
            ></path>
            <path
              fill="#fff"
              d="M389.143 255.99c-1.413 5.527-13.13 14.374-15.208 14.233-2.332-.155-13.257 2.629-16.691 4.636a7.061 7.061 0 00-3.421 5.102c-.551-.282-.961-.975 0-2.671 4-7.138 18.685-8.381 19.787-8.918.438-.255 7.859-6.191 15.533-12.382z"
              opacity="0.25"
            ></path>
          </g>
        </g>
        <g id="Table">
          <path
            fill="url(#paint19_linear_1_6)"
            d="M169.491 297.784l-2.728-1.922-2.727-1.88c-.41.593-10.261 14.755-20.212 40.988-9.144 24.027-20.041 63.347-20.041 113.564h6.671c0-93.947 38.641-150.199 39.037-150.75z"
          ></path>
          <path
            fill="url(#paint20_linear_1_6)"
            d="M229.136 297.784l-2.728-1.922-2.728-1.88c-.424.593-10.275 14.755-20.211 40.988-9.145 24.027-20.056 63.347-20.056 113.564h6.671c.014-93.947 38.656-150.199 39.052-150.75z"
          ></path>
          <path
            fill="url(#paint21_linear_1_6)"
            d="M420.336 297.784l2.728-1.922 2.728-1.908c.41.593 10.261 14.755 20.211 40.987 9.13 24.056 20.084 63.376 20.084 113.593h-6.657c-.056-93.947-38.712-150.199-39.094-150.75z"
          ></path>
          <path
            fill="url(#paint22_linear_1_6)"
            d="M360.692 297.784l2.728-1.922 2.728-1.908c.409.593 10.261 14.755 20.211 40.987 9.144 24.112 20.041 63.39 20.041 113.607h-6.671c0-93.961-38.641-150.213-39.037-150.764z"
          ></path>
          <path
            fill="#9CACF2"
            d="M426.4 294.491a4.41 4.41 0 01-4.41 4.409H122.963a4.41 4.41 0 110-8.819H421.99a4.411 4.411 0 014.41 4.41z"
          ></path>
          <path
            fill="#C7CFFF"
            d="M479.274 294.491a4.388 4.388 0 01-1.288 3.122 4.393 4.393 0 01-3.122 1.287H421.99a4.41 4.41 0 100-8.819h52.874a4.41 4.41 0 014.41 4.41z"
          ></path>
        </g>
        <g id="Desktop">
          <path
            fill="#EEF8FF"
            d="M226.408 160.871v96.787h-69.764a10.006 10.006 0 01-10.007-10.006v-76.775a10.006 10.006 0 0110.007-10.006h69.764z"
          ></path>
          <path
            fill="#C7CFFF"
            d="M226.408 257.658v-96.787a10.01 10.01 0 00-10.007 10.006v76.775a10.004 10.004 0 0010.007 10.006z"
          ></path>
          <path
            fill="#000"
            d="M191.681 257.658h-24.479l6.063-37.539s2.827-5.569 9.173-1.964c5.116 2.939 2.713 28.253 9.243 39.503z"
            opacity="0.25"
          ></path>
          <path
            fill="#9CACF2"
            d="M157.124 278.604l16.141-58.499a2.64 2.64 0 012.079-1.902 2.645 2.645 0 012.613 1.054 25.96 25.96 0 014.339 17.752c-1.342 14.755-9.893 42.952-9.893 42.952l-15.279-1.357z"
          ></path>
          <path
            fill="#7189E2"
            d="M185.816 277.021h-32.649a6.499 6.499 0 00-4.597 1.905 6.499 6.499 0 000 9.194 6.502 6.502 0 004.597 1.904h32.649a6.495 6.495 0 006.019-4.01 6.49 6.49 0 00-1.413-7.093 6.495 6.495 0 00-4.606-1.9z"
          ></path>
          <path
            fill="url(#paint23_linear_1_6)"
            d="M182.438 200.869c0 4.636-2.445 8.395-5.456 8.395-3.01 0-5.441-3.759-5.441-8.395 0-4.636 2.431-8.395 5.441-8.395 3.011 0 5.456 3.759 5.456 8.395z"
          ></path>
        </g>
        <g id="Laptop">
          <path
            fill="#9CACF2"
            d="M386.203 285.516l-42.118-2.163v6.728h42.118v-4.565z"
          ></path>
          <path
            fill="#C7CFFF"
            d="M353.018 290.081h-81.213a2.082 2.082 0 01-2.007-1.569l-12.805-52.775a2.073 2.073 0 01.387-1.759 2.069 2.069 0 011.62-.785h81.212a2.075 2.075 0 012.007 1.569l12.721 52.775a2.052 2.052 0 01-1.922 2.544z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M350.389 287.608h-81.213a2.067 2.067 0 01-2.007-1.583l-12.805-52.818c-.07-.304-.07-.62-.002-.925a2.09 2.09 0 011.122-1.412c.281-.136.589-.207.901-.207h81.199a2.063 2.063 0 012.006 1.583l12.791 52.761c.083.306.094.627.032.937a2.073 2.073 0 01-2.024 1.664z"
          ></path>
          <path
            fill="url(#paint24_linear_1_6)"
            d="M306.376 260.061c1.06 2.827 0 5.752-2.247 6.643-2.247.89-5.046-.65-6.12-3.435-1.074-2.784 0-5.752 2.261-6.643 2.262-.89 5.06.608 6.106 3.435z"
          ></path>
        </g>
        <g id="FavCard">
          <path
            fill="url(#paint25_radial_1_6)"
            d="M487.815 213.451c39.224-16.908 58.797-58.973 43.717-93.954-15.079-34.98-59.101-49.63-98.325-32.722-39.224 16.909-58.797 58.974-43.718 93.955 15.08 34.98 59.101 49.63 98.326 32.721z"
          ></path>
          <path
            fill="url(#paint26_linear_1_6)"
            d="M500.63 103.785h-98.568a5.936 5.936 0 00-5.937 5.936v61.312a5.937 5.937 0 005.937 5.936h98.568a5.936 5.936 0 005.936-5.936v-61.312a5.936 5.936 0 00-5.936-5.936z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M429.735 163.768a5.95 5.95 0 01-5.936-5.95v-10.629c0-.391-.077-.779-.228-1.14-.15-.362-.37-.69-.648-.966l-2.134-2.12a3.672 3.672 0 010-5.159l2.134-2.12a2.96 2.96 0 00.876-2.106v-10.614a5.947 5.947 0 015.936-5.95v2.982a2.968 2.968 0 00-2.968 2.968v10.6a5.905 5.905 0 01-1.738 4.24l-2.134 2.12a.682.682 0 000 .962l2.134 2.134a5.919 5.919 0 011.738 4.24v10.628a2.984 2.984 0 002.968 2.983v2.897z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M472.956 116.985a5.962 5.962 0 015.502 3.695c.298.725.45 1.501.448 2.284v10.6c.001.788.311 1.544.863 2.106l2.134 2.134a3.656 3.656 0 011.069 2.58 3.656 3.656 0 01-1.069 2.579l-2.134 2.12a3.011 3.011 0 00-.863 2.106v10.629a5.96 5.96 0 01-5.95 5.95V160.8a2.997 2.997 0 002.982-2.982v-10.629a5.852 5.852 0 011.739-4.24l2.134-2.134a.708.708 0 000-.961l-2.134-2.134a5.855 5.855 0 01-1.739-4.24v-10.516a2.981 2.981 0 00-2.982-2.968v-3.011z"
          ></path>
          <path
            fill="#EEF8FF"
            d="M464.942 131.557a6.387 6.387 0 00-2.078-1.389 6.386 6.386 0 00-4.903 0 6.387 6.387 0 00-2.078 1.389l-4.537 4.537-4.523-4.537a6.408 6.408 0 00-7.189-1.743 6.399 6.399 0 00-3.602 3.625 6.4 6.4 0 001.788 7.178l4.523 4.537 9.059 9.06 9.032-9.06 4.537-4.537a6.408 6.408 0 001.368-6.986 6.42 6.42 0 00-1.397-2.074z"
          ></path>
        </g>
        <path
          id="Gear"
          fill="#B3CEE8"
          d="M380.479 109.085v-2.827a1.972 1.972 0 00-2.021-1.993h-4.664a15.004 15.004 0 00-1.809-4.353l3.307-3.307a1.979 1.979 0 000-2.827l-1.965-1.908a1.98 1.98 0 00-2.826 0l-3.308 3.307a14.619 14.619 0 00-4.282-1.894V88.62a1.966 1.966 0 00-1.965-1.965h-2.826a1.967 1.967 0 00-1.965 1.965v4.664a14.791 14.791 0 00-4.353 1.81l-3.364-3.223a1.96 1.96 0 00-2.181-.444 1.97 1.97 0 00-.646.444l-2.021 2.021a1.954 1.954 0 000 2.827l3.307 3.307a14.292 14.292 0 00-1.809 4.353h-4.678a1.962 1.962 0 00-1.964 1.965v2.827a1.967 1.967 0 001.964 1.964h4.678c.36 1.541.972 3.011 1.809 4.353l-3.25 3.237a1.925 1.925 0 00-.453 2.184c.105.243.259.462.453.643l2.021 2.021a1.95 1.95 0 001.413.613 1.942 1.942 0 001.414-.613l3.25-3.435a14.774 14.774 0 004.354 1.809v4.679a1.957 1.957 0 001.206 1.84c.24.101.498.153.758.153h2.827a1.973 1.973 0 001.416-.546 1.97 1.97 0 00.605-1.391v-4.678a14.616 14.616 0 004.325-1.866l3.307 3.308a1.955 1.955 0 002.827 0l1.979-1.894a1.98 1.98 0 00.6-1.414 1.97 1.97 0 00-.6-1.413l-3.308-3.307a15.132 15.132 0 001.809-4.354h4.608a1.964 1.964 0 002.021-1.978zm-19.617 6.544a8.108 8.108 0 01-4.978-.735 8.094 8.094 0 01-2.108-12.981 8.1 8.1 0 0112.977 2.137 8.096 8.096 0 01-1.538 9.326 8.116 8.116 0 01-4.353 2.253z"
        ></path>
        <g id="Spinner" fill="#EEF8FF">
          <path d="M318.786 175.782a2.107 2.107 0 01-2.078-1.908 17.376 17.376 0 00-4.886-10.278 17.376 17.376 0 00-21.333-2.699 17.37 17.37 0 00-7.292 8.737l4.056.848-5.13 3.759-2.134 1.583h-.396l-1.484-2.699-3.039-5.244 4.056.848a21.54 21.54 0 0141.78 4.706c.036.298.008.6-.082.886a2.107 2.107 0 01-1.166 1.29 2.092 2.092 0 01-.872.171z"></path>
          <path d="M279.734 181.534a2.107 2.107 0 012.078 1.908 17.372 17.372 0 0026.219 12.977 17.374 17.374 0 007.292-8.737l-4.057-.848 5.131-3.773 2.134-1.569h.396l1.54 2.657 3.039 5.243-4.07-.848a21.554 21.554 0 01-41.78-4.706 2.109 2.109 0 012.078-2.304z"></path>
          <path d="M279.988 175.782l-.282.198-.113-.198h.395z"></path>
        </g>
        <path
          id="Floor"
          fill="#000"
          d="M482.963 461.367a12.465 12.465 0 01-12.565 11.632H122.709a12.242 12.242 0 01-12.226-12.819 11.99 11.99 0 013.929-8.282 12.716 12.716 0 018.636-3.364h347.689a12.236 12.236 0 0111.471 7.97c.578 1.553.835 3.208.755 4.863z"
          opacity="0.28"
        ></path>
        <g id="Lines">
          <g id="RightLines">
            <path
              stroke="url(#paint27_linear_1_6)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4.169"
              d="M472.956 203.074h69.863"
            ></path>
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4.169"
              d="M472.956 215.526h45.228"
            ></path>
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4.169"
              d="M472.956 227.695h45.228"
            ></path>
            <path
              style={{ mixBlendMode: "color-dodge" }}
              fill="url(#paint28_radial_1_6)"
              d="M472.956 227.977c6.877 0 12.452-5.574 12.452-12.451 0-6.877-5.575-12.452-12.452-12.452s-12.452 5.575-12.452 12.452 5.575 12.451 12.452 12.451z"
            ></path>
          </g>
          <g id="LeftLines">
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4.169"
              d="M110.342 271.269H40.479"
            ></path>
            <path
              stroke="url(#paint29_linear_1_6)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4.169"
              d="M110.342 283.721H65.128"
            ></path>
            <path
              stroke="url(#paint30_linear_1_6)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4.169"
              d="M110.342 295.89H65.128"
            ></path>
            <path
              style={{ mixBlendMode: "color-dodge" }}
              fill="url(#paint31_radial_1_6)"
              d="M115.573 282.552c6.348-2.646 9.348-9.937 6.702-16.284-2.646-6.348-9.937-9.348-16.284-6.702-6.347 2.646-9.348 9.937-6.702 16.284 2.646 6.348 9.937 9.348 16.284 6.702z"
            ></path>
          </g>
        </g>
        <path
          id="LaptopLight"
          fill="url(#paint32_radial_1_6)"
          d="M352.381 285.049l-12.791-52.761a2.06 2.06 0 00-2.007-1.583h-81.198a2.076 2.076 0 00-1.583.735l-.494-.268 14.953-81.015s117.31-58.202 140.489 11.434c1.413 4.354 40.168 60.436 40.889 64.281 10.643 57.679-98.258 59.177-98.258 59.177z"
        ></path>
        <g id="Plants">
          <g id="PlantRight">
            <path
              fill="url(#paint33_linear_1_6)"
              d="M564.005 304.455a295.668 295.668 0 01-29.553 57.114c1.894-13.78 15.109-104.476 38.882-133.973 2.996 19.151-2.658 50.231-9.329 76.859z"
            ></path>
            <path
              fill="#B3CEE8"
              d="M540.855 351.478c-2.064 3.406-4.241 6.784-6.403 10.091a293.625 293.625 0 01-10.713 15.081c-.071-1.23-4.156-68.209 17.087-102.893 7.491 25.61 3.435 58.881.029 77.721z"
            ></path>
            <path
              fill="#000"
              d="M573.334 227.553a1603.502 1603.502 0 00-13.88 55.39c-2.134 9.272-4.169 18.572-5.978 27.9-1.809 9.329-3.491 18.699-4.565 28.126l-1.654-.197c1.216-9.484 3.053-18.841 5.003-28.169 1.951-9.328 4.113-18.6 6.389-27.857a1449.194 1449.194 0 0114.685-55.193z"
              opacity="0.25"
            ></path>
            <path
              fill="#000"
              d="M540.826 273.757c-1.286 7.25-2.36 14.529-3.307 21.836-.947 7.307-1.753 14.6-2.332 21.936-.58 7.335-1.032 14.67-1.06 22.02a164.355 164.355 0 001.145 21.921l-1.654.212a165.967 165.967 0 01-.735-22.161c.17-7.378.777-14.728 1.484-22.063.707-7.335 1.668-14.643 2.742-21.921 1.074-7.279 2.29-14.558 3.717-21.78z"
              opacity="0.25"
            ></path>
          </g>
          <g id="PlantLeft">
            <path
              fill="#B3CEE8"
              d="M80.633 393.483s-33.045-20.155-45.468-59.361c34.57 4.409 65.382 61.213 65.382 61.213l-19.914-1.852z"
            ></path>
            <path
              fill="#000"
              d="M35.164 334.15a726.737 726.737 0 0127.462 26.175c8.919 8.975 17.64 18.162 25.752 27.915l-1.286 1.045c-7.859-9.893-16.353-19.221-25.06-28.38-8.706-9.159-17.68-18.049-26.867-26.755z"
              opacity="0.25"
            ></path>
            <path
              fill="url(#paint34_linear_1_6)"
              d="M118.723 426.499a3.84 3.84 0 01-1.894.198 262.09 262.09 0 01-23.73-23.221c-40.79-23.279-80.35 25.822-80.35 25.822s16.48-57.312 62.654-47.687c46.189 9.71 43.32 44.888 43.32 44.888z"
            ></path>
            <path
              fill="#000"
              d="M12.748 429.298a114.852 114.852 0 0120.367-24.225c7.887-6.982 17.158-12.876 27.66-15.109a40.293 40.293 0 0115.929-.17 45.105 45.105 0 0114.84 5.795c1.173.65 2.233 1.484 3.35 2.205l1.653 1.131 1.555 1.258c1.032.848 2.092 1.667 3.095 2.544l1.484 1.413 1.414 1.498a27.887 27.887 0 014.409 6.784 22.076 22.076 0 012.092 7.943h-1.682a20.853 20.853 0 00-1.823-7.307 26.189 26.189 0 00-4.085-6.501l-1.3-1.414-1.413-1.413c-.976-.862-2.007-1.682-3.01-2.516l-1.499-1.229-1.611-1.131c-1.088-.721-2.106-1.541-3.251-2.191a44.297 44.297 0 00-14.43-5.851 39.162 39.162 0 00-15.548 0c-10.388 2.021-19.617 7.759-27.56 14.572a115.44 115.44 0 00-20.636 23.914z"
              opacity="0.25"
            ></path>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_6"
          x1="310.107"
          x2="297.246"
          y1="36.353"
          y2="463.841"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C4259"></stop>
          <stop offset="1" stopColor="#0B2935"></stop>
        </linearGradient>
        <radialGradient
          id="paint1_radial_1_6"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(58.83427 -25.36239 22.31889 51.77413 98.377 229.494)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="0.04" stopColor="#4181FF" stopOpacity="0.95"></stop>
          <stop offset="0.32" stopColor="#536AFF" stopOpacity="0.62"></stop>
          <stop offset="0.56" stopColor="#6158FF" stopOpacity="0.35"></stop>
          <stop offset="0.76" stopColor="#6B4BFF" stopOpacity="0.16"></stop>
          <stop offset="0.91" stopColor="#7243FF" stopOpacity="0.04"></stop>
          <stop offset="1" stopColor="#7440FF" stopOpacity="0"></stop>
        </radialGradient>
        <linearGradient
          id="paint2_linear_1_6"
          x1="51.687"
          x2="102.045"
          y1="53.242"
          y2="467.883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint3_radial_1_6"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(116.151 232.938) scale(12.4518)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint4_linear_1_6"
          x1="29328.1"
          x2="29328.1"
          y1="-38.202"
          y2="997.087"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1_6"
          x1="1250.09"
          x2="281.858"
          y1="1279.92"
          y2="2027.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1_6"
          x1="1455.56"
          x2="492.973"
          y1="1495.72"
          y2="2241.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1_6"
          x1="1345.42"
          x2="271.782"
          y1="1616.01"
          y2="2316.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1_6"
          x1="3467.46"
          x2="4007.38"
          y1="2196.35"
          y2="2196.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1_6"
          x1="13035.4"
          x2="13021.4"
          y1="8751.25"
          y2="8218.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1_6"
          x1="10448.4"
          x2="10434.4"
          y1="8817.22"
          y2="8284.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1_6"
          x1="398.726"
          x2="390.684"
          y1="256.796"
          y2="389.639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2B2B"></stop>
          <stop offset="1" stopColor="#111"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_1_6"
          x1="4534.98"
          x2="5023.95"
          y1="6675.17"
          y2="5724.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_1_6"
          x1="360.607"
          x2="343.732"
          y1="231.539"
          y2="279.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F78B7C"></stop>
          <stop offset="1" stopColor="#FFB7A9"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1_6"
          x1="16562.1"
          x2="18676.4"
          y1="11891"
          y2="17584.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1_6"
          x1="8078.95"
          x2="7978.36"
          y1="3946.5"
          y2="4461.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F78B7C"></stop>
          <stop offset="1" stopColor="#FFB7A9"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_1_6"
          x1="11714.7"
          x2="11835.3"
          y1="4489.23"
          y2="5225.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2B2B"></stop>
          <stop offset="1" stopColor="#111"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_1_6"
          x1="6991.95"
          x2="6413.17"
          y1="6311.93"
          y2="5674.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1_6"
          x1="20288.1"
          x2="19128.4"
          y1="8639.05"
          y2="11919.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F78B7C"></stop>
          <stop offset="1" stopColor="#FFB7A9"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_1_6"
          x1="145.874"
          x2="146.467"
          y1="240.811"
          y2="342.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D5BD8"></stop>
          <stop offset="1" stopColor="#C7CFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_1_6"
          x1="8108.5"
          x2="-2045.73"
          y1="27524.5"
          y2="35749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D5BD8"></stop>
          <stop offset="1" stopColor="#C7CFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_1_6"
          x1="13317.9"
          x2="21628.1"
          y1="30134.1"
          y2="35931.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D5BD8"></stop>
          <stop offset="1" stopColor="#C7CFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_1_6"
          x1="12612.8"
          x2="12832.4"
          y1="26482.3"
          y2="37589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D5BD8"></stop>
          <stop offset="1" stopColor="#C7CFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_1_6"
          x1="1530.08"
          x2="1432.91"
          y1="3119.29"
          y2="2203.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_1_6"
          x1="2333.33"
          x2="2120.29"
          y1="2584.35"
          y2="1953.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint25_radial_1_6"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(6438.81934 -2775.65854 2178.32434 5053.15646 47519.5 -11544.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="0.04" stopColor="#4181FF" stopOpacity="0.95"></stop>
          <stop offset="0.32" stopColor="#536AFF" stopOpacity="0.62"></stop>
          <stop offset="0.56" stopColor="#6158FF" stopOpacity="0.35"></stop>
          <stop offset="0.76" stopColor="#6B4BFF" stopOpacity="0.16"></stop>
          <stop offset="0.91" stopColor="#7243FF" stopOpacity="0.04"></stop>
          <stop offset="1" stopColor="#7440FF" stopOpacity="0"></stop>
        </radialGradient>
        <linearGradient
          id="paint26_linear_1_6"
          x1="33052.4"
          x2="35119.9"
          y1="3492.95"
          y2="11412.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_1_6"
          x1="-nan"
          x2="-nan"
          y1="-nan"
          y2="-nan"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint28_radial_1_6"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(8725.02 4000.62) scale(219.401)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint29_linear_1_6"
          x1="-nan"
          x2="-nan"
          y1="-nan"
          y2="-nan"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_1_6"
          x1="-nan"
          x2="-nan"
          y1="-nan"
          y2="-nan"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint31_radial_1_6"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(1981.28 5034.62) scale(219.401)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint32_radial_1_6"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(201.32 443.276) scale(328.863)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F"></stop>
          <stop offset="1" stopColor="#0FF" stopOpacity="0"></stop>
        </radialGradient>
        <linearGradient
          id="paint33_linear_1_6"
          x1="16563.1"
          x2="11063.6"
          y1="21300.3"
          y2="27948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint34_linear_1_6"
          x1="1475.68"
          x2="3215.41"
          y1="13460.5"
          y2="17018.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E84FF"></stop>
          <stop offset="1" stopColor="#7440FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default DevSVG;